import { Seo } from '../../components/Seo';

/**
 * Where the payment page sends a person back to. It says nothing about whether they paid, because
 * only the server knows: the app asks, and the receipt comes by email.
 */
export function PaymentComplete() {
  return (
    <>
      <Seo
        noindex
        title="Back to Transport Book"
        description="Return to the Transport Book app after paying for your plan."
      />
      <section className="page-hero">
        <div className="container">
          <div className="eyebrow">Payment</div>
          <h1>You can go back to Transport Book.</h1>
          <p className="lead">
            If you paid, the app updates by itself within a minute and your receipt comes by email.
            If you left without paying, nothing was charged and you can try again from the app.
          </p>
        </div>
      </section>
    </>
  );
}
